export const PERMISSIONS = {
    screenCodes: {
        // home: [],
        salesstatistics: ["salesreport", "OrderStatistics", "CallHistoryReport", "campaign-metrics"],
        gooddaystatistics: ["usetheservice", "servicereviews"],
        accountstatistics: ["ReportNewAccountsStatistics", "ReportLoginStatistics"],
        // SystemManagement: ["UserManagement", "AuthorityRole"],
        ManageCustomerBase: ["CustomersOverview", "CustomerSet"],
        GieoQueHoiViec: ["GieoQueLucHao"],
        TuVi: ["sudungdichvutuvi"],
        BaoCaoVanHanh: ["ApiAccessReport", "BaoCaoZalo"],
        ThanhVienGiaDinh: ["FamilyMemberReport"],
        NguoiDung: ["NguoiDungMoi", "PremiumReport"],
        PhanTichTapKhachHang: ["PhanTichTapKhachHang"],
        OnlineStore: ["OnlineStore", "EnergyActivation"],
    },
    featureCodes: {
        // home: [],
        salesreport: ["export"],
        OrderStatistics: ["export"],
        ReportNewAccountsStatistics: ["export"],
        ReportLoginStatistics: ["export"],
        UserManagement: ["add", "edit", "delete", "lock", "unlock"],
        AuthorityRole: ["add", "edit", "delete"],
        CustomerSet: ["add", "edit", "delete", "export"],
        CustomersOverview: ["view"],
        usetheservice: ["export"],
        servicereviews: ["view"],
        GieoQueLucHao: ["export"],
        sudungdichvutuvi: ["export"],
        CallHistoryReport: ["export"],
        ApiAccessReport: ["export"],
        BaoCaoZalo: ["export"],
        FamilyMemberReport: ["export"],
        NguoiDungMoi: ["export"],
        PremiumReport: ["export"],
        PhanTichTapKhachHang: ["view"],
        OnlineStore: ["export"],
        EnergyActivation: ["export"],
        "campaign-metrics": ["view", "export"],
    },
    name: {
        "home": "Trang chủ",
        "dashboard": "Bảng điều khiển",
        "report": "Báo cáo",
        "view": "Xem",
        "add": "Thêm",
        "edit": "Sửa",
        "delete": "Xóa",
        "export": "Xuất",
        "order": "Đơn hàng",
        "account": "Tài khoản",
        "salesstatistics": "Bán hàng",
        "OrderStatistics": "Đơn hàng",
        "salesreport": "Báo cáo doanh thu",
        "accountstatistics": "Tài khoản",
        "SystemManagement": "Quản lý hệ thống",
        "UserManagement": "Quản lý người dùng",
        "AuthorityRole": "Phân quyền",
        "ReportNewAccountsStatistics": "Báo cáo tài khoản mới",
        "ReportLoginStatistics": "Báo cáo đăng nhập",
        "UserManagement": "Quản lý người dùng",
        "AuthorityRole": "Phân quyền",
        "lock": "Khóa",
        "unlock": "Mở khóa",
        "ManageCustomerBase": "Quản lý tập khách hàng",
        "CustomerSet": "Quản lý tập khách hàng",
        "AddCustomerBase": "Thêm tập khách hàng",
        "CustomersOverview": "Tổng quan tập khách hàng",
        "gooddaystatistics": "Chọn ngày tốt",
        "usetheservice": "Sử dụng dịch vụ",
        "servicereviews": "Đánh giá dịch vụ",
        "GieoQueHoiViec": "Gieo quẻ hỏi việc",
        "GieoQueLucHao": "Sử dụng dịch vụ",
        "TuVi": "Tử Vi",
        "sudungdichvutuvi": "Sử dụng dịch vụ Tử Vi",
        "CallHistoryReport": "Cuộc gọi telesale",
        "ApiAccessReport": "Thống kê truy cập API",
        "FamilyMemberReport": "Thống kê thành viên gia đình",
        "TruyCapAPI": "Truy cập API",
        "ThanhVienGiaDinh": "Thành viên gia đình",
        "NguoiDung": "Người dùng",
        "NguoiDungMoi": "Người dùng mới",
        "PhanTichTapKhachHang": "Phân tích tập khách hàng",
        "OnlineStore": "Online Store",
        "EnergyActivation": "Kích hoạt năng lượng",
        "BaoCaoVanHanh": "Báo cáo vận hành",
        "BaoCaoZalo": "Báo cáo Zalo",
        "campaign-metrics": "Báo cáo chiến dịch",
        "PremiumReport": "Đăng ký dịch vụ"
    }
}

export const FUNCTION = {
    add: "add",
    edit: "edit",
    delete: "delete",
    lock: "lock",
    unlock: "unlock",
    view: "view",
    export: "export"
}
export const PATH = {
    home: "home",
    salesstatistics: "salesstatistics",
    OrderStatistics: "OrderStatistics",
    salesreport: "salesreport",
    accountstatistics: "accountstatistics",
    SystemManagement: "SystemManagement",
    UserManagement: "UserManagement",
    AuthorityRole: "AuthorityRole",
    ReportNewAccountsStatistics: "ReportNewAccountsStatistics",
    ReportLoginStatistics: "ReportLoginStatistics",
    CustomerSet: "CustomerSet",
    AddCustomerBase: "AddCustomerBase",
    CallHistoryReport: "CallHistoryReport",
    ApiAccessReport: "ApiAccessReport",
    FamilyMemberReport: "FamilyMemberReport",
    NguoiDungMoi: "NguoiDungMoi",
    OnlineStore: "OnlineStore",
    EnergyActivation: "EnergyActivation",
    BaoCaoZalo: "baocaozalo",
    sudungdichvutuvi: "sudungdichvutuvi",
    "campaign-metrics": "campaign-metrics",
    PremiumReport: "PremiumReport",
}